export default timetableService => {
    return function (input, key, filters) {

        var filterVal = filters[key];

        for (var i = 0, l = input.length; i < l; i++) {
            for (var j = 0, m = input[i].classes.length; j < m; j++) {
                var c = input[i].classes[j];
                if (filterVal === 'Show all' || filterVal === c[key]) {
                    c[key + 'Filter'] = true;
                } else {
                    c[key + 'Filter'] = false;
                }
            }

            input[i] = timetableService.checkForVisibleChildren(input[i], filters);
            input[i].hiddenByLocationFilter = input[i].locations.indexOf(filterVal) === -1 &&
                filterVal !== 'Show all';
        }

        return input;
    }
};